import {userAPI} from '../api/userAPI';

const useSubscribeEmail = () => {
    const [subscribeEmail, { isLoading }] = userAPI.useSubscribeEmailMutation();
    const subscribe = async(email: string) => {
        await subscribeEmail({ email }).unwrap();
    };
    return { subscribe, isLoading };
};

export default useSubscribeEmail;